import React from 'react'
import './Footer.css';

function Footer() {
  return <div className='footer-container'>
    <h6 className='footer-header'>Designed & Built by Joey Chang, 2026</h6>
    </div>;
}

export default Footer